import { Box, Typography } from "@mui/material";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import React, { useState, useEffect } from "react";
import { setState } from "../analyzeSlice";
import { useSelector, useDispatch } from "react-redux";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function Table() {
  const state = useSelector((store) => store.analyze);
  const dispatch = useDispatch();
  const { customerTDPrepared, customerChecked } = state;
  const [tableRows, setTableRows] = useState([]);
  const { rows, columns } = customerTDPrepared;
  const [rowSelectionModel, setRowSelectionModel] = React.useState(
    rows.map((i) => i.series)
  );
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });

  useEffect(() => {
    dispatch(setState("customerChecked", rowSelectionModel));
  }, [rowSelectionModel]);

  function QuickSearchToolbar() {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter placeholder="Filter.." variant="outlined" />
      </Box>
    );
  }

  return (
    <Box>
      <CollapseSection title="Customer Quota Details">
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.series}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[20, 50, 100]}
          checkboxSelection={true}
          disableRowSelectionOnClick
          sx={{
            "& .MuiDataGrid-footerContainer": {
              display: "none !important",
            },
          }}
          disableColumnMenu
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={setRowSelectionModel}
          slots={{ toolbar: QuickSearchToolbar }}
        />
      </CollapseSection>
    </Box>
  );
}
